var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContent',{attrs:{"title":_vm.$t('comingSoon.title')}},[(_vm.value)?_c('json-box',{attrs:{"value":_vm.value}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }